$('#slickServices').slick({
  slidesToShow: 1,
  dots: true,
  arrows: false,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 1200,
      settings: 'unslick'
    },
  ]
});